export const tr = {
    'success-change': 'Ürün güncellendi'
};
